import queryString from 'query-string';

import { API_URL } from '../configs';
import { LOGIN_SESSION_EXPIRED } from '../routes';
import { getSession, removeSession } from './session';

const baseURL = API_URL;

const createRequest = async (
  method,
  endpoint,
  body,
  additionalOptions = null,
) => {
  const headers = new Headers();
  const session = getSession();

  if (session) {
    const b64encodedSession = btoa(JSON.stringify(session));
    headers.set('authorization', `Basic ${b64encodedSession}`);
  }

  if (additionalOptions?.headers) {
    Object.keys(additionalOptions.headers).forEach((key) => {
      headers.set(key, additionalOptions.headers[key]);
    });
  }

  if (
    !additionalOptions?.useNativeHeaders &&
    !headers.get('content-type') &&
    method !== 'GET' &&
    body
  ) {
    headers.set('content-type', 'application/json');
    // avoid double JSON.stringify calls after token refresh
    if (typeof body !== 'string') {
      body = JSON.stringify(body);
    }
  }

  const options = {
    method,
    headers,
  };

  if (method === 'GET') {
    if (body && Object.keys(body).length && !endpoint.includes('?')) {
      const searchParams = queryString.stringify(body, {
        arrayFormat: 'bracket',
      });
      endpoint += `?${searchParams}`;
    }
  } else if (body) {
    options.body = body;
  }

  const resource = `${baseURL}${endpoint}`;
  try {
    const response = await fetch(resource, options);
    const contentType = response.headers.get('Content-Type');
    let parsedResponse;
    if (contentType.includes('application/json')) {
      parsedResponse = await response.json();
    }

    if (contentType.includes('text/csv')) {
      parsedResponse = await response.text();
    }

    if (400 <= response.status) {
      // redirect to login
      if (response.status === 401) {
        removeSession();
        window.location = LOGIN_SESSION_EXPIRED;
        return;
      }

      if (parsedResponse) {
        // eslint-disable-next-line
        throw {
          data: parsedResponse,
          status: response.status,
        };
      } else {
        throw response;
      }
    }

    return {
      data: parsedResponse,
      status: response.status,
    };
  } catch (err) {
    throw err;
  }
};

const fetchRequest = {
  get: (...data) => createRequest('GET', ...data),
  post: (...data) => createRequest('POST', ...data),
  put: (...data) => createRequest('PUT', ...data),
  patch: (...data) => createRequest('PATCH', ...data),
  delete: (...data) => createRequest('DELETE', ...data),
  options: (...data) => createRequest('OPTIONS', ...data),
};

export default fetchRequest;
